import { get, post } from '@/utils/request';

export function recordVisitor(data) {
  return post('/visitor/record', data, { skipToken: true, silentAuth: true });
}

export function getVisitorCount(params) {
  return get('/visitor/count', params, { skipToken: true, silentAuth: true });
}
